import React from "react";
import "../styles/milestones.css";
import Marque from "./Marque";
import BigText from "./BigText";
import LineChart from "./LineChart";
import MaqueeBar from "./MarqueeBar";
import CombinedChart from "./CombinedChart";

import GlowShade from "./GlowShade";

export default function MileStones() {
  return (
    <div className="milestones">
      <Marque text={"Milestones"} id={"milestones"} />
      <BigText text={"Milestones"} align="left" top="150px" top2="140px" />
      <GlowShade
        color="#824581"
        top="80%"
        left="-4%"
        height="200px"
        width="200px"
      />
      <div className="hm-bars">
        <MaqueeBar
          textArray={[
            "Successfully solved over 450+ problems on LeetCode, showcasing strong problem-solving skills.",
            "🏅 Secured GeekforGeeks Institute Rank 4 in DSA.",
            "Solved 600+ problems and Scored 1200+ in GeeksforGeeks.",
          ]}
          speed={100}
        />
        <MaqueeBar
          textArray={[
            "🥇 Secured first prize in the event 'WEB DEV MASTERY' in the National Event VALIANT 2K23.",
            "🥇Attained first prize in the event 'DATA DYNAMO' in the National Event VALIANT 2K23.",
            "🥈 Secured second prize in the event 'DEBUGGING DURBY' in the National Event VALIANT 2K23.",
          ]}
          speed={80}
        />
        <MaqueeBar
          textArray={[
            "Designed App templates for BLOODPLUS in Figma.",
            "BEST PROJECT AWARD recognition for the project 'BLOODPLUS' from CODINZA.",
            "⭐ Published a research paper on 'Comparative Analysis of Pretrained Models for Speech Enhancement in Noisy Environment' in IC4S 2023.",
          ]}
          speed={90}
        />
        <MaqueeBar
          textArray={[
            "Participated in Smart India Hackathon 2022.",
            "Designed vector portraits for various clients using Adobe Illustrator and Adobe Photoshop.",
            "Co-ordinated and managed the technical team for the event 'CODE CHAMP' in the National Event VALIANT 2K22.",
          ]}
          speed={100}
        />
        <MaqueeBar
          textArray={[
            "NSS Volunteer at Vishnu Institute of Technology.",
            "Successfully completed the course 'Full Stack Web Development using Node.js' from Coding Ninjas.",
            "Successfully completed the course 'Data Structures and Algorithms in JAVA' from Coding Ninjas.",
          ]}
        />
        <MaqueeBar
          textArray={[
            "Successfully completed the course 'Database Management System' from Coding Ninjas.",
            "Successfully completed the course 'Advanced Full Stack Web Development' from CODINZA.",
            "🥇 Secured Highest SGPA 10 in the 3-1 semester in the Department of Computer Science and Engineering.",
          ]}
          speed={80}
        />
        <MaqueeBar
          textArray={[
            "Co-ordinated and managed 'COGNOSCENTE CLUB' in Vishnu Institute of Technology.",
            "🌟 Recognized as the 'Top 1% Web Developer Voice in LinkedIn' by LinkedIn Community.",
            "Experienced as a Full Stack Developer Intern in Multiple Startups.",
          ]}
          speed={90}
        />
      </div>
      <div className="charts">
        <CombinedChart />
        <LineChart />
      </div>
      <GlowShade
        color="#00BBFF99"
        top="60%"
        left="80%"
        top2="50%"
        left2="50%"
        height="200px"
        width="200px"
      />

      <GlowShade
        color="#00A86B"
        top="140%"
        left="70%"
        top2="120%"
        height="200px"
        width="200px"
      />
    </div>
  );
}
